export default{
   //首页
    menus:[
        {
            title1:'成功案例',title2:'CASE',type:'1',
            imgs:[
                {
                    imgSrc:require("../../assets/img/case/case-1caoyuan.jpg"),
                    title:'草原有害生物天网大数据平台',
                    type:'case',
                    path:'case'
                },{
                    imgSrc:require("../../assets/img/case/case-2zuozhanjiaoxue.jpg"),
                    title:'战场教学实景三维',
                    type:'case',
                    path:'case'
                },{
                    imgSrc:require("../../assets/img/case/4haidao.png"),
                    title:'医学地理侦查系统',
                    type:'case',
                    path:'case'
                }
            ]
            
        },
        {
            title1:'全景展示',title2:'PANORAMA',type:'1',
            imgs:[
                {
                    imgSrc:require("../../assets/img/qibaoge.jpg"),
                    title:'七宝阁书院',
                    type:'vr',
                    path:'http://www.hexishuzi.com/pano/pano?filename=QiBaoGeShuYuan'
                },{
                    imgSrc:require("../../assets/img/Zhangjiakou.jpg"),
                    title:'张家口大石砬',
                    type:'vr',
                    path:'http://www.hexishuzi.com/pano/pano?filename=Zhangjiakou'
                },{
                    imgSrc:require("../../assets/img/jiangxi.jpg"),
                    title:'北京IT商会',
                    type:'vr',
                    path:'http://www.hexishuzi.com/pano/pano?filename=JiangXiShiZhouNian'
                }
            ]
        }
    ],
    lists:[
        {nameT:'首页',nameB:'HOME',path:'home'},
        {nameT:' ',nameB:'PRODUCTS',path:'overseas',type:'overseas'},
        {nameT:'产品展示',nameB:'PRODUCTS',path:'product'},
        {nameT:'解决方案',nameB:'SOLUTIONS',path:'solution'},
        {nameT:'成功案例',nameB:'CASES',path:'case'},
        {nameT:'关于我们',nameB:'ABOUT US',path:'aboutUs'},
    ],
    detailName:'查看',
    // 底部
    footer:{
        title:'北京禾溪数字技术有限公司',
        tel:'电话',
        address:'地址:北京市朝阳区红军营南路15号瑞普大厦C座1101室',
        web:'网址',
        postcode:'邮编',
        beian:'备案号:京ICP备19052144号-1',
        beian2:'京公网安备 11010502039430号'
    },
    // 关于 我们
    aboutUsMenus:[
		{name:'公司介绍',title2:'INTRODUCTION',type:'1'},
		{name:'团队优势',title2:'ADVANTAGE',type:'2'},
		{name:'公司宗旨',title2:'PURPOSE',type:'3'},
	],
    intro:{
        p1:`北京禾溪数字技术有限公司（简称：禾溪数字）立足于传统3S领域，积极向物联网、VR&AR及大数据服务等领域不断开拓。为自然资源（林业、地质、国土规划）、环保、基础设施（铁路、公路、电力）、应急、农业、水利、文旅、教育等行业提供信息化解决方案。公司形成了底层开发的二三维GIS系统HexiEarth、无人机处理系统HexiUAV、全景VR系统Hexi PanoVR、地理信息MR系统HexiEarth MR等平台，我们能为行业客户提供数据获取（星空地）、数据加工、数据建库管理、数据集成及应用展示等定制化服务。`,
        p2:`禾溪数字拥有资深的互联网与IT专家、一流卓越的产品研发和项目管理团队，团队核心骨干成员来自空客防务与空间、搜狐、测绘局等单位。在不断研究和创新中获得了多项软件著作权。`,
        p3:`禾溪数字秉承“专业提升品质、联合创造价值”的服务理念，
						致力于为客户和合作伙伴提供安全、灵活、符合客户需求的产品及解决方案。
						公司一直努力以优质的服务赢得客户的长久信任，以创新的模式最大限度地帮助客户提升竞争优势和价值，
						并凭借不断增强的创新能力、突出的灵活定制能力、日趋完善的交付能力赢得各行业客户的信任与合作。`
    },
    aboutusTeam:{
        p1:`国内外卫星遥感数据定制分发，以高效、高质量的数据服务，满足不同行业客户需求`,
        p2:`专业的二三维一体化GIS系统集成，具有多年的行业项目建设实施经验`,
        p3:`定制化的企业信息化管理解决方案，根据用户不同的IT应用环境现状及未来的发展要求，提供全面的产品资源整合`,
        p4:`精准的大数据挖掘，服务旅游/教育等领域`
    },
    aboutusPurpose:{
        p1:`发展员工：尊重每个员工的价值和创造，为每个人提供发展的舞台和成就事业的机会`,  
        p2:`成就客户：以满足客户的需求来构造公司的组织、技术、市场服务体系以及企业的价值观，与客户共同构造一个相互依存的生态系统`,  
        p3:`客户服务理念：专业提升品质、联合创造价值，坚持“完美、快捷、双赢”的合作发展思路`,  
    },
    // 自然资源
    casesList:[
        {
            name:'自然资源',
            title2:'NATURAL RESOURCES',
            detailList:[
                {id:'1.1',name:'草原有害生物天网大数据平台',imgUrl:require('../../assets/img/case/case-1caoyuan.jpg')},
                {id:'1.2',name:'空间数据&非空间数据管理系统',imgUrl:require('../../assets/img/case/case-1data.jpg')},
                {id:'1.3',name:'智能农机系统',imgUrl:require('../../assets/img/case/case-1nongji.jpg')},
                {id:'1.4',name:'自然保护区可视化系统',imgUrl:require('../../assets/img/case/case-1hanshiqiao.jpg')},
                {id:'1.5',name:'林业三维可视化系统',imgUrl:require('../../assets/img/case/case-1linye3D.jpg')},
                {id:'1.6',name:'林业遥感卫星影像元数据管理系统',imgUrl:require('../../assets/img/case/case-1linyedata.jpg')},
            ]
        },
        {
            name:'军方',
            title2:'MILITARY',
            detailList:[
                {id:'2.1',name:'战场教学实景三维',imgUrl:require('../../assets/img/case/case-2zuozhanjiaoxue.jpg')},
                {id:'2.2',name:'作战物资配送系统',imgUrl:require('../../assets/img/case/case-2zuozhanwuzi.jpg')},
                {id:'2.3',name:'信息采报系统',imgUrl:require('../../assets/img/case/case-2caibao.jpg')},
                {id:'2.4',name:'智能闭环打印系统',imgUrl:require('../../assets/img/case/case-2dayin.jpg')},
                {id:'2.5',name:'H辐射预测预警系统',imgUrl:require('../../assets/img/case/case-2hefushe.jpg')},
                {id:'2.6',name:'空地红蓝对抗仿真系统',imgUrl:require('../../assets/img/case/case-2duikang.jpg')},
            ]
        },
        {
            name:'基础设施',
            title2:'INFRASTRUCTURE',
            detailList:[
                {id:'3.1',name:'铁路内外业一体化系统',imgUrl:require('../../assets/img/case/3neiwaiye.jpg')},
                {id:'3.2',name:'湖南电网一张图',imgUrl:require('../../assets/img/case/3hunan.jpg')},
                {id:'3.3',name:'核工业元数据管理系统',imgUrl:require('../../assets/img/case/3hegongye.jpg')},
                {id:'3.4',name:'大渡河系统',imgUrl:require('../../assets/img/case/3daduhe.jpg')},
            ]
        },
        {
            name:'医疗/疾控',
            title2:'MEDICAL DISEASE CONTROL',
            detailList:[
                {id:'4.1',name:'医疗管理系统',imgUrl:require('../../assets/img/case/4yiliao.png')},
                {id:'4.2',name:'医学元数据管理系统',imgUrl:require('../../assets/img/case/4yuanshuju.jpg')},
                {id:'4.3',name:'医学地理侦查系统',imgUrl:require('../../assets/img/case/4haidao.png')},
                {id:'4.4',name:'流调管理系统',imgUrl:require('../../assets/img/case/4liudiao.png')},
                
            ]
        },
        {
            name:'金融/证券',
            title2:'FINANCE AND SECURITIES',
            detailList:[
                {id:'5.1',name:'某证券系统',imgUrl:require('../../assets/img/case/case-zhengquan.png')},
                {id:'5.2',name:'某银行风控系统',imgUrl:require('../../assets/img/case/case-yinhang.png')},
            ]
        },
        {
            name:'教育',
            title2:'EDUCATION',
            detailList:[
                {id:'6.1',name:'智能测评指导大数据平台',imgUrl:require('../../assets/img/case/6zhineng.jpg')},
                {id:'6.2',name:'图伴教育系统',imgUrl:require('../../assets/img/case/6tuban.jpg')},
                {id:'6.3',name:'教学信息管理系统',imgUrl:require('../../assets/img/case/6jiaoxue.jpg')},
                {id:'6.4',name:'地理环境虚拟平台',imgUrl:require('../../assets/img/case/6linda.jpg')},
            ]
        },
        {name:'AI',
        title2:'ARTIFICIAL INTELLIGENCE',
            detailList:[
                {id:'7.1',name:'无人机落水人员识别',imgUrl:require('../../assets/img/case/case-7luoshui.jpg')},
                {id:'7.2',name:'智看草原',imgUrl:require('../../assets/img/case/case-7caoyuan.jpg')},
                {id:'7.3',name:'裸土识别',imgUrl:require('../../assets/img/case/case-7luotu.jpg')},
                {id:'7.4',name:'垃圾识别',imgUrl:require('../../assets/img/case/case-7laji.jpg')},
            ]
        },
        {name:'3D&XR',type:'xr'}
    ],
    //解决方案
    solutionLeftMenuList:[
        {id:'1',title:'信息化系统建设'},
		{id:'2',title:'AI识别统计分析'},
		{id:'3',title:'军工行业信息化系统建设'},
		{id:'4',title:'三维基础平台'},
		{id:'5',title:'真实虚拟三维地理空间XR建设'},
		{id:'6',title:'可视化展示'},
		{id:'7',title:'数字沙盘制作'},
		{id:'8',title:'GIS数据处理'},
    ],
    digital_p1:`以多媒体和数字化技术为手段，
						可结合传统实物沙盘，制作交互式电子沙盘，通过多媒体展示与互动，
						可以充分展示自然地理区域全貌及自然资源分布等。用于应急指挥、城市规划、线路设计等`,
    digital_p2:`可提供基础数据`,
    digital_p3:`2.0米分辨率国产卫星影像数据（标准镶嵌成果）`,
    digital_p4:`0.8米分辨率国产卫星影像数据（标准镶嵌成果）`,
    digital_p5:`主要城区0.5米分辨率卫星影像数据 （标准镶嵌成果）`,
    digital_p6:`区域覆盖数字高程模型DEM数据（5米格网，国家2000坐标系，标准镶嵌成果）`,
    digital_p7:`区域覆盖电子地图数据（行政区界、道路、地名等）`,
    digital_p8:`可通过触摸式多媒体交互设备和其他分屏对沙盘进行详细介绍和控制 360度观看沙盘的3D效果，
						多方位、多层次地快速获取精确、优美、逼真的动态信息；`,
    digital_p9:`可通过VR/AR眼镜或裸眼3d显示屏对沙盘，切换视角，给参观者更直观立体的体验`,
    GIS_p1:`基于底层开发的遥感数据处理软件HexiOrtho及专业影像镶嵌匀色软件，对海量遥感卫星影像数据进行预处理、正射纠正、融合、匀色、镶嵌及分幅裁切输出等。`,
    GIS_p2:`依据遥感卫星影像，基于ArcGIS等软件开展土地覆盖分类要素解译提取及变化对比分析工作。`,
    
    //产品展示
    productsLeftMenuList:[
        {
            id:'1',
            label:'软件产品',
            proMenuList:[
                {id:'1.1',title:'HexiEarth虚拟地球'},
                {id:'1.2',title:'HexiPanoVR平台'},
                {id:'1.3',title:'HexiOrtho'},
                {id:'1.4',title:'HexiUAV'},
            ]
        },{
            id:'2',
            label:'卫星数据产品',
            proMenuList:[
                {id:'2.1',title:'高分一号(GF-1)'},
                {id:'2.2',title:'高分二号(GF-2)'},
                {id:'2.3',title:'资源三号(ZY-3)'},
                {id:'2.4',title:'高景(SuperView)'},
                {id:'2.5',title:'美国DG(WV/GEOEYE)'},
                {id:'2.6',title:'法国AIRBUS(SPOT/Pleiades)'},
            ]
        },{
            id:'3',
            label:'硬件产品',
            proMenuList:[
                {id:'3.1',title:'利亚德'},
            ]
        }
    ],
    // 软件产品
    hexiEarth_p1:`HexiEarth虚拟地球系统（3DGIS+MR）是公司自主底层研发的三维GIS展示升级系统。`,
    hexiEarth_p2:`可分层叠加管理影像、矢量、DEM、地名、三维模型等数据，以表达地形、地貌、建筑、道路、桥梁等信息，同时能够加载二维电子地图数据，形成二三维一体的地理环境。实现地理环境三维真实再现及可视化显示。通过人机交互操作进行飞行控制，从不同维度、角度、高度对场景进行沉浸式漫游浏览和相关信息查询。`,
    hexiEarth_p3:`包括底图数据：全球100米分辨率遥感影像、30米DEM数据、全国30米卫星影像。`,
    hexiEarth_p4:`用户能够在三维场景中快速地加载、浏览、测量、分析和标注三维地理信息数据和专题数据，并实现虚拟地球的飞行漫游体验和对三维空间场景的多视角浏览。`,
    hexiEarth_p5:`亮点：`,
    hexiEarth_p6:`海量空间数据加载和管理；`,
    hexiEarth_p7:`沉浸式飞行漫游展示；`,
    hexiEarth_p8:`结合非空间数据的成果展示与空间分析查询；`,
    hexiEarth_p9:`实时监控和追踪的接入。`,
    hexiEarth_p10:`三维平台主要功能：`,
    hexiEarth_p11:`1、数据加载和显示;2、数据导出;3、坐标系投影转换;4、工程管理;5、三维场景操作;6、图层管理;7、图层属性显示和设置;
    8、空间查询;9、空间分析`,

    hexiPanoVr_p1:`基于地理位置的HexiPanoVR全景内容定制展示平台，将720°全视角的真实场景正确展开到2D图片上，
    通过佩戴VR眼镜实现沉浸式的观看和展示。`,
    hexiPanoVr_p2:`内容包括任何需要展示的成果、场景，以及相应的文字、图片、声音等介绍。可按照行业、区域等主题分类定制拍摄制作全景，
    集成到平台统一展示。`,
    hexiPanoVr_p3:`亮点：`,
    hexiPanoVr_p4:`720°全视角还原再现拍摄时的真实场景；
    声频、视频、动画等专题内容定制；移动端、PC端灵活部署、访问；
    内容可持续更新；多场景切换、应用领域广泛。`,

    hexiOrtho_p1:`HexiOrtho是一款针对多源卫星遥感影像数
									字正射影像图和数字高程模型产品生产专业的处理软件。它无需人工干预，
									可以快速的完成控制点、连接点的自动生成、平差解算、数字高程模型（DEM）生成以及数字正射影像产品（DOM）生成。`,
    hexiOrtho_p2:`HexiOrtho秉承着简单理念，每一步设计都尽可能让用户较少操作而能得到满意的效果。
									简单、易用、高效是本软件最大的特点，因此特别适用于大面积、紧急任务生产。本软件长期与实际数据生产单位相结合，
									广泛应用于国土、测绘等行业诸多部门，口碑良好，软件的核心算法为卫星遥感数据生产项目提供了强有力的保证，
									节约了大量的人力和财力。`,
    hexiOrtho_p3:`(1)支持国内外主流卫星传感器影像`,
    hexiOrtho_p4:`中低分辨率：HJ1A/1B、LandSat系统MSS、TM/ETM等`,
    hexiOrtho_p5:`中高分辨率：高分一号、天绘、资源3号、资源02C、
									遥感2/8/24、SPOT系列、RapidEye、P5、CEERS等后续发射的卫星，HexiOrtho也会陆续进行支持。`,
    hexiOrtho_p6:`(2)异时相、异分辨率间影像的自动搜寻同名点`,
    hexiOrtho_p7:`HexiOrtho提供强大的自动搜寻同名点的驱动，采用多种策略提高计算机的运算性能，
									结合计算机视觉技术保证了异时相、异分辨率影像间同名点自动提取的精度能够达到亚像元级。`,
    hexiOrtho_p8:`图左为2米分辨率高分一号全色影像，图右为30米分辨率HJ星多光谱影像`,
    hexiOrtho_p9:`(3)创新型自适应RFM模型`,
    hexiOrtho_p10:`当影像不满足通用的RFM模型是（原始影像或者地理基准影像几何均匀度不够或者其他原因），系统提供具有创新性的自适应RFM模型，可以应对数据复杂多变的情况。`,
    hexiOrtho_p11:`(4)区域网匀色功能`,
    hexiOrtho_p12:`多景有地理邻接关系的正射影像的区域匀色功能，将所有输入的正射影像的范围并集空间内构建颜色区域网，并进行色彩区域网平差。可指定颜色模板亦可均衡化自适应颜色，最终能够达到影像接边处色彩均匀过渡自然的效果。`,
    hexiOrtho_p13:`41景高分二号影像拼接图（图左为未匀色，图右为区域网匀色）`,
    hexiOrtho_p14:`(5)平面区域网平差功能`,
    hexiOrtho_p15:`通常卫星数据生产原始数据资料是有历史DEM和历史地理基准影像，单纯的影像配准很难达到接边精度的需求，因此，引入平面区域网平差功能可以既能保证产品的绝对配准精度，也能达到较好的接边的精度。平面区域网平差支持上千景影像，可以达到像元级精度。`,
    hexiOrtho_p16:`41景高分二号影像平差后连接点分布`,
    hexiOrtho_p17:`(6)影像自动定量化质检技术及二次精纠正`,
    hexiOrtho_p18:`正射影像与基准影像进行自动同名检查点搜寻，可统计出每个检查点的误差，从而自动形成质检报告，
									解决了针对正射影像产品生产后快速对其进行定量化质量检查的难题。对于质检不达标的正射影像，可以利用现有的同名检查点进行二次精纠正，
									直到满足精度为止。`,
    hexiUAV_p1:`HexiUAV针对无人机数据和航空影像提供了强大的影像处理像素单元引擎，
									使用者无需专业知识，无需人工干预，即可将数千张影像快速制作成量测级精度的数字表面模型、
									数字正射影像图和真实三维密集点云。`,
    hexiUAV_p2:`（1）全自动处理、无需人工干预`,
    hexiUAV_p3:`HexiUAV为数字摄影测量时代一款具有里程碑意义的产品，
									省去了过多的人机交互如划分航带、航带间连接、空中三角测量、人工匀色、镶嵌线编辑等，真正实现全自动化。`,
    hexiUAV_p4:`（2）操作者无需具备专业知识`,
    hexiUAV_p5:`HexiUAV的使用极其方便，只需要将影像和POS添加进去，一键即可完成快拼图、
									数字高程模型以及三维密集点云的生产。`,
    hexiUAV_p6:`（3）极速像素处理引擎`,
    hexiUAV_p7:`HexiUAV为原生64位程序，采用多核处理器和GPU联合加速，
									使用创新性的算法，使得处理速度得到了极大的提高，CPU推荐使用i7或以上处理器，GPU推荐使用GTX970或以上高端显卡。
									 GPU和CPU双模自动切换：当计算机配置有高端GPU，程序即可充分利用计算资源，当没有高端GPU，
									 程序自动切换至普通CPU程序运行。`,
    hexiUAV_p8:`（4）支持任意航迹`,
    hexiUAV_p9:`HexiUAV采用计算机视觉+摄影测量相结合的技术，
									有别于传统的航空摄影测量软件对于数据航带严格划分的要求，可以支持任意航迹所拍摄照片的自动处理。`,
    hexiUAV_p10:`（5）相机自检校系统`,
    hexiUAV_p11:`当相机参数不准确或者没有相机参数的情况下，
									HexiUAV可仅仅依靠影像间的连接点信息，运用具有划时代意义的相机自检校算法，
									近似逼近地计算出相机的主距、像主点坐标、径向畸变和偏心畸变参数，
									完美解决了无人机测量在非测绘领域（如农业、林业、驴友等）的应用问题。`,
    hexiUAV_p12:`（6）数据质量自检查系统`,
    hexiUAV_p13:`HexiUAV可以根据影像的纹理质量自动剔除坏片（如全云层覆盖、全水域覆盖等），
									只将飞行的有效区域进行处理，无需人工挑片。`,
    hexiUAV_p14:`（7）真正射影像生产`,
    hexiUAV_p15:`HexiUAV可支持利用系统生产的高精度DSM进行全自动真正射影像产品的生产。`,
    hexiUAV_p16:`（8）自动匀光匀色`,
    hexiUAV_p17:`HexiUAV支持全自动的匀光匀色，采用自创的色彩区域网平差的算法以达到整体颜色一致的目的。`,
    hexiUAV_p18:`（9）支持精确GPS辅助空三`,
    hexiUAV_p19:`当POS系统中有差分后的GPS数据，可以支持GPS辅助空中三角测量，不需要控制点绝对精度可以达到0.2米以内。`,
    hexiUAV_p20:`（10）测绘级精度`,
    hexiUAV_p21:`生产的DOM、DEM产品可以满足从1:10000到1:500各个比例尺下的测绘精度要求。`,
    hexiUAV_p22:`（11）支持各种相机类型`,
    hexiUAV_p23:`支持各种类型的相机，既能支持全画幅的微单和单反相机（如索尼微单、佳能5D3、尼康等），也能支持普通的卡片相机甚至手机。`,
    hexiUAV_p24:`（12）支持消费级大疆无人机`,
    hexiUAV_p25:`支持大疆公司的消费无人机（精灵、悟等系列），为广大用户单位提供测绘级影像地图服务。`,
    hexiUAV_p26:`利用大疆公司SDK，研发了方便快捷的航迹飞行APP，
									方便的航迹规划后一键完成飞机的起飞、按航迹飞行、拍照、GPS数据获取、降落，一键式操作使得普通大众航拍地图成为现实，而不需要专业的操控手，
									使得应用门槛进一步降低。`,
    // 卫星数据产品
    weixingIntroGF1:[
        {word_item:`“高分一号”是中国高分辨率对地观测系统的首发星，突破了高空间分辨率、
									多光谱与宽覆盖相结合的光学遥感等关键技术，设计寿命5至8年。 高分辨率对地观测系统工程是
									《国家中长期科学和技术发展规划纲要(2006～2020年)》确定的16个重大专项之一，由国防科工局、总装备部牵头实施。`},
        {word_item:`“高分一号”是中国高分辨率对地观测系统的第一颗卫星，
									由中国航天科技集团公司所属空间技术研究院研制。于2013年4月26日12时13分04秒由长征二号丁运载火箭成功发射，
									开启了中国对地观测的新时代。`},
        {word_item:`“高分一号”是我国高分辨率对地观测卫星系统重大专项（简称“高分专项”）的第一颗卫星。
									“高分专项”于2010年5月全面启动，计划到2020年建成我国自主的陆地、大气和海洋观测系统。`},
        {word_item:`“高分一号”的全色分辨率是2m，多光谱分辨率为8m，并且增加了宽幅多光谱相机，
									该相机的性能在国内投入运行的对地观测卫星中最强。宽幅多光谱相机幅宽达到了800Km，
									而法国发射的SPOT6卫星幅宽仅有60Km。“高分一号”可以在更短的时间内对一个地区重复拍照，
									其重复周期只有4天，而世界上同类卫星的重复周期大多为10余天， 
									“高分一号”实现了高空间分辨率和高时间分辨率的完美结合。`},
        {word_item:`“高分一号“卫星发射成功后，为国土资源部门、农业部门、环境保护部门提供高精度、
									宽范围的空间观测服务，在地理测绘、海洋和气候气象观测、水利和林业资源监测、
									城市和交通精细化管理，疫情评估与公共卫生应急、地球系统科学研究等领域发挥重要作用。`}
    ],
    weixingIntroGF2:[
        {word_item:`高分二号卫星，是2014年8月19日11时15分，中国在太原卫星发射中心用长征四号乙运载火箭成功发射遥感卫星，
									卫星顺利进入预定轨道，分辨率优于1米卫星影像可在平台中查询到，
									同时还具有高辐射精度、高定位精度和快速姿态机动能力等特点。`},
        {word_item:`高分二号标志着中国遥感卫星进入亚米级“高分时代”。
									高分二号卫星主要用户是国土资源部、住建部、交通运输部、林业局。2015年3月6日，它正式投入使用。`},
        {word_item:`高分二号卫星是高分辨率对地观测系统重大专项首批启动立项的重要项目之一，
									是目前我国分辨率最高的光学对地观测卫星，具有米级空间分辨率、
									高辐射精度、高定位精度和快速姿态机动能力，主要用户为国土资源部、
									住房和城乡建设部、交通运输部、林业局，同时还将为其他用户部门和有关区域提供示范应用服务。`},
        {word_item:`高分二号卫星主要用户是国土资源部、住建部、交通运输部、林业局。
									高分二号卫星投入使用后，将与在轨运行的高分一号卫星相互配合，
									推动高分辨率卫星数据应用，为土地利用动态监测、矿产资源调查、
									城乡规划监测评价、交通路网规划、森林资源调查、荒漠化监测等行业和首都圈等区域应用提供服务支撑。`},
    ],
    weixingIntroZY3:[
        {word_item:`资源三号测绘卫星，简称ZY3，是中国第一颗民用高分辨率光学传输型测绘卫星，卫星于2012年1月9日发射，星载一台地面分辨率2.1m的正视全色TDI CCD相机、两台地面分辨率3.6m的前视和后视全色TDI CCD相机、一台地面分辨率5.8m的正视多光谱相机，数据可用于地形图制图、高程建模以及资源调查等。卫星设置寿命5年，能长期、连续、稳定地获取立体全色影像、多光谱影像以及辅助数据，可对地球南北纬84度以内的地区实现无缝影像覆盖。`},
        {word_item:`资源三号卫星标准数据产品根据处理程度不同，分为1A级、1C级、2级、2A级和2C 级产品，各级产品主要说明如下：`},
        {word_item:`1A级（预处理级辐射校正影像产品）：经数据解析、均一化辐射校正、去噪、MTFC、CCD拼接、波段配准等处理的影像数据；并提供卫星直传姿轨数据生产的RPC文件。`},
        {word_item:`1C级（高精度预处理级辐射校正影像产品）：经数据解析、均一化辐射校正、去噪、MTFC、CCD拼接、波段配准等处理的影像数据；并提供整轨精化的姿轨数据生产的RPC文件。`},
        {word_item:`2级（系统级几何校正影像产品）：经相对辐射校正、系统级几何校正后的影像产品。`},
        {word_item:`2A级（预处理级几何校正影像产品）：1A级数据经几何校正、地图投影生成的影像产品。`},
        {word_item:`2C级（高精度预处理级几何校正影像产品）：1C级数据经几何校正、地图投影生成的影像产品。`},
    ],
    weixingIntroSuperView:[
        {word_item:`SuperView-1（高景一号） 01/02星，于2016 年12 月28日，SuperView-1 03/04星，于2018年1月9日，两次均以一箭双星的方式成功发射。这四颗卫星以90 度夹角在同一轨道运行，组成SuperView-1星座，分辨率0.5米，重访周期缩短至1天。`},
        {word_item:`SuperView-1 全色分辨率0.5 米，多光谱分辨率2 米，轨道高度530 公里，幅宽12 公里，过境时间为上午10:30。由于SuperView-1 卫星具有很高的敏捷性，可设定拍摄连续条带、多条带拼接、按目标拍摄多种采集模式，此外还可以进行立体采集。SuperView-1 单次最大可拍摄60 km×70 km 影像。`},
        {word_item:`全色分辨率高达 0.5 米，多光谱分辨率为 2 米，能够彰显细腻的地物细节，适用于高精度地图制作、变化监测和影像深度分析。`},
        {word_item:`具有全色波段和四个标准多光谱波段：蓝色、绿色、红色和近红外波段。`},
        {word_item:`星下点幅宽高达 12 公里，大幅提升观测能力，形成大面积地表观测和环境监测具有独特优势。`},
        {word_item:`迅速精准实现星下点成像，常规侧摆角最大为30°，执行重点任务时可达到 45°。`},
        {word_item:`具有星下点成像、侧摆成像、连续条带、多条带拼接、立体成像、多目标成像等多种工作模式。`},
        {word_item:`4T 星上储存空间，形成强大的采集能力，单颗卫星每天可采集 60 万平方公里。在全球任何地方，可实现每天观测一次。`},
        
    ],
    WorldView_p1:  `WorldView-1卫星`,
    WorldView_p2:  `WorldView 1(视界1)卫星于2007年9月18日发射，该卫星成为全球分辨率最高、响应速度最敏捷的商业成像卫星。卫星于高度496km、倾角98度、周期93.4分的太阳同步轨道上，平均的重访周期1.7天，星载大容量全色成像系统每天能够拍摄多达55万平方公里的0.5米分辨率的影像。卫星还将具备现代化的地理定位精度能力和极佳的响应能力，能够快速瞄准要拍摄的目标和有效的进行同轨立体成像。采集能力是快鸟卫星的4倍。`,
    WorldView_p3:  `WorldView-2卫星`,
    WorldView_p4:  `WorldView-2卫星于2009年10月6日发射,提供0.5米全色图像和1.8米分辨率的多光谱图像。该卫星将使Digitalglobe公司能够为世界各地的商业用户提供满足其需要的高性能图像产品。星载多光谱遥感器不仅将具有4个业内标准谱段（红、绿、蓝、近红外），还将包括四个额外（海岸、黄、红边和近红外2）。多样性的谱段将为用户提供进行精确变化检测和制图的能力，由于WorldView卫星对指令的响应速度更快，因此图像的周转时间（从下达成像指令到 接收到图像所需的时间）仅为几个小时而不是几天。`,
    WorldView_p5:  `WorldView-2卫星能提供独有的8波段高清晰商业卫星影像。除了四个常见的波段外（蓝色波段：450-510；绿色波段：510-580；红色波段：630-690；近红外线波段：770-895）。`,
    WorldView_p6:  `新的彩色波段分析`,
    WorldView_p7:  `（1）海岸波段（400-450）这个波段支持植物鉴定和分析，也支持基于叶绿素和渗水的规格参数表的深海探测研究。由于该波段经常受到大气散射的影响，已经应用于大气层纠正技术。`,
    WorldView_p8:  `（2）黄色波段（585—625）过去经常被说成是yellow-ness特征指标，是重要的植物应用波段。该波段将被作为辅助纠正真色度的波段，以符合人类视觉的欣赏习惯。`,
    WorldView_p9:  `（3）红色边缘波段（705-745） 辅助分析有关植物生长情况，可以直接反映出植物健康状况有关信息。`,
    WorldView_p10:  `（4）近红外2 波段（860-1040） 这个波段部分重叠在NIR 1波段上，但较少受到大气层的影响。该波段支持植物分析和单位面积内生物数量的研究。`,
    WorldView_p11:  `WorldView-3卫星`,
    WorldView_p12:  `2014年8月13号,Digitalglobe公司的Worldview3（WV3）卫星已经成功发射并正式运行，WV3卫星提供31厘米全色分辨率1.24米多光谱分辨率和3.7米红外短波分辨率。`,
    WorldView_p13:  `WorldView-3的平均回访时间不到1天，每天能够采集多达680,000平方公里范围的数据，相对其他亚米级商业卫星有着更广的光谱范围，使其特征提取/变化监测/植物分析等领域有着卓越的表现。`,
    GeoEye_p1:`Geoeye卫星`,
    GeoEyeLists:[
        {word_item:`通过 GeoEye Foundation，该公司还为学术机构和非政府组织提供支持。GeoEye 总部位于弗吉尼亚州杜勒斯，是一家在纳斯达克股票交易所公开上市的企业，交易代码为 GEOY。该公司保持了一个综合的质量管理体系 (QMS)，整个企业已经通过 ISO 认证。`},
        {word_item:`2008年9月6日，该公司从美国加州范登堡空军基地发射了 GeoEye-1 号卫星。`},
        {word_item:`GeoEye-1卫星拥有达到0.41米分辨率(黑白)的能力，简单来说这意味着，从轨道采集并由SGI Altix 350系统处理的高分辨率图像将能够辨识地面上16英寸或者更大尺寸的物体。以这个分辨率，人们将能够识别出位于棒球场里放着的一个盘子或者数出城市街道内的下水道出入孔的个数。`},
        {word_item:`GeoEye-1不仅能以0.41米黑白(全色)分辨率和1.65米彩色(多谱段)分辨率搜集图像，而且还能以3米的定位精度精确确定目标位置。因此，一经投入使用，GeoEye-1将成为当今世界上能力最强、分辨率和精度最高的商业成像卫星。`},
        {word_item:`GeoEye-1 照片产品和解决方案现在已经大量推出，其地面分辨率分别为0.5米、1米、2米和4米。照片产品有彩色和黑白两种。彩色照片包含四种波长的颜色：蓝色、绿色、红色和近红外。商业客户可以通过多种途径购买 GeoEye-1 照片。服务专家现在可在购买 GeoEye-1 照片产品和增值解决方案方面提供帮助。`},
        {word_item:`包括GoogleEarth、GoogleMap、Tom Clancy's H.A.W.X等软件及游戏都使用了该卫星的地球照片。`},
        {word_item:`GEOEYE-1 规格`},
        {word_item:`全色传感器：0.41 meters x 0.41 meters`},
        {word_item:`多普段传感器：1.65 meters x 1.65 meters`},
        {word_item:`光谱范围：450–800 nm`},
        {word_item:`450–510 nm (blue)`},
        {word_item:`510–580 nm (green)`},
        {word_item:`655–690 nm (red)`},
        {word_item:`780–920 nm (near IR)`},
        {word_item:`扫描宽度：15.2 km`},
        {word_item:`Off-Nadir Imaging:Up to 60 degrees`},
        {word_item:`动态范围：11 bits per pixel`},
        {word_item:`任务寿命预期：大于10 years`},
        {word_item:`Revisit Time:Less than 3 days`},
        {word_item:`轨道高度：681 km`},
        {word_item:`Nodal Crossing:10:30 a.m.`},
    ],
    spot_p1:`SPOT系列卫星`,
    spot_p2:`SPOT系列卫星是法国空间研究中心（CNES）研制的一种地球观测卫星系统，至今已发射SPOT卫星1-7号，1986年已来，SPOT已经接收、存档超过7百万幅全球卫星数据，提供了准确、丰富、可靠、动态的地理信息源，满足了制图、农业、林业、土地利用、水利、国防、环保地质勘探等多个应用领域不断变化的需要。`,
    spot_p3:`卫星参数`,
    spot_p4:`Spot卫星采用的太阳同步准回归轨道,通过赤道时刻为地方时上午10：30，回归天数（重复周期）为26d。由于采用倾斜观测，所以实际上可以对同一地区用4～5d的时间进行观测。`,
    spot_p5:`Spot1，2，3上搭载的传感器HRV采用CCD（charge coupled device )S作为探测元件来获取地面目标物体的图像。HRV具有多光谱XS具和PA两种模式，其余全色波段具有10m的空间分辨率，多光谱具有20m的空间分辨率。Spot4上搭载的是HRVIR传感器和一台植被仪。Spot5上搭载包括两个高分辨几何装置（HRG）和一个高分辨率立体成像装置（HRS）传感器。`,
    spot_p6:`数据参数`,
    spot_p7:`Spot的一景数据对应地面60km×60km的范围，在倾斜观测时横向最大可达91Km，各景位置根据GRS（spot grid reference systerm)由列号K和行号J的交点（节点）来确定。各节点以两台HRV传感器同时观测的位置基础来确定，奇数的K对应于HRV1，偶数的K对应于HRV2。倾斜观测时，由于景的中心和星下点的节点不一致，所以把实际的景中心归并到最近的节点上。`,
    spot_p8:`谱段参数`,
    spot_p9:`（1）绿谱段（500～590nm）：该谱段位于植被叶绿素光谱反射曲线最大值的波长附近，同时位于水体最小衰减值的长波一边，这样就能探测水的混浊度和10～20m的水深。`,
    spot_p10:`（2）红谱段（610—680nm）：这一谱段与陆地卫星的MSS的第5通道相同（专题制图仪TM仍然保留了这一谱段），它可用来提供作物识别、裸露土壤和岩石表面的情况。`,
    spot_p11:`（3）近红外谱段（790—890nm）：能够很好的穿透大气层。在该谱段，植被表现的特别明亮，水体表现的非常黑。尽管硅的光谱灵敏度可以延伸到1100urn，但设计时为了避免大气中水汽的影响，并没有把近红外谱段延伸到990nm。同时，红和近红外谱段的综合应用对植被和生物的研究是相当有利的。`,
    spot_p12:`该系统的多谱段图像配准精度相当高，通常采用二向色棱镜进行光谱分离，粗制多谱段图像的配准精度误差小于0.3个象元。`,
    spot_p13:`数据应用范围`,
    spot_p14:`Spot的数据被世界上14个地点的地面站所接收，数据的应用目的和Landsat相同，以陆地上的资源环境调查和检测为主。由于它的分辨率不高，可以用于地图的制作，通过立体观测和高程观测，可以制作1：5万的地形图。`,
    spot_p15:`SPOT卫星优势`,
    spot_p16:`SPOT卫星比美国“陆地卫星”的优越之处是，SPOT卫星图像的分辨率可达10～20m，超过了“陆地卫星”系统，加之SPOT卫星可以拍摄立体像对，因而在绘制基本地形图和专题图方面将会有更广泛的应用。为了达到这些要求，SPOT卫星在轨道设计、飞行平台和传感器等方面都有它自己的独到之处。`,
    pleiades_p1:`Pleiades卫星`,
    pleiades_p2:`Pleiades高分辨率卫星星座由2颗完全相同的卫星Pleiades1和Pleiades2组成。Pleiades1已于2011年12月17日成功发射并开始商业运营，Pleiades2于2012年12月1日成功发射并已成功获取第一幅影像。`,
    pleiades_p3:`双星配合可实现全球任意地区的每日重访，最快速满足客户对任何地区的超高分辨率数据获取需求。`,
    pleiades_p4:`Pleiades卫星特点`,
    pleiades_p5:`1.双子星：完全相同的两颗卫星`,
    pleiades_p6:`2.每日重放：纬度高于40°地区，30度角可实现每日重访`,
    pleiades_p7:`3.同步轨道：相互成180°夹角在相同轨道运行`,
    pleiades_p8:`4.编程响应：每8小时上传并更新编程计划，每天3次；可以在紧急的状态下接受提 前4小时的编程指令；全天24小时自动处理`,
    pleiades_p9:`5.高采集能力：单星最高日采集能力为一百万平方公里;单星日采集景数约600景;幅宽达到20km，在0.5米高分卫星中幅宽最大`,
    pleiades_p10:`6.高灵活度：4个控制力矩陀螺仪（CMGs)；接收模式可分为点对点采集、条带采集、立体数据采集、线性采集、持续监测采集`,

    //利亚德部分


    liyades:[
        {oneTitle:'小间距LED',twoTitle:'VDS系列 | TXF系列',liyadeImg:require('../../assets/img/liyade/liyade1.jpg')},
        {oneTitle:'常规LED',twoTitle:'NCV系列 | NEV系列',liyadeImg:require('../../assets/img/liyade/liyade2.jpg')},
        {oneTitle:'创意LED',twoTitle:'LED广告机',liyadeImg:require('../../assets/img/liyade/liyade3.jpg')},
        {oneTitle:'LED模组',twoTitle:'MiniBox-LCH系列 | SV系列',liyadeImg:require('../../assets/img/liyade/liyade4.jpg')},
        {oneTitle:'租赁LED',twoTitle:'IDsn系列 | vClear系列',liyadeImg:require('../../assets/img/liyade/liyade5.jpg')},
        {oneTitle:'液晶产品',twoTitle:'Planar Q系列 智能电视',liyadeImg:require('../../assets/img/liyade/liyade6.jpg')},
        {oneTitle:'会议一体机',twoTitle:'TimeSight 135 | TXP一体机',liyadeImg:require('../../assets/img/liyade/liyade7.jpg')},
        {oneTitle:'VR产品',twoTitle:'Prime41',liyadeImg:require('../../assets/img/liyade/liyade8.jpg')},
    ],
    liyade_p1:'--利亚德代理商--',
    liyade_p2:'全球视效科技领创者--利亚德品牌'

}